var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "login-page login-3" }, [
    _c("div", { staticClass: "site-wrapper" }, [
      _c("div", { staticClass: "login-box" }, [
        _c(
          "div",
          { staticClass: "box-wrapper" },
          [_vm._m(0), _vm._v(" "), _c("router-view")],
          1
        ),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "content-box" }, [
        _c("h1", [
          _vm._v(_vm._s(_vm.$t("layout_login.short_term_finance"))),
          _c("br"),
          _vm._v("\n        " + _vm._s(_vm.$t("layout_login.made_simple"))),
          _c("br"),
        ]),
        _vm._v(" "),
        _c("p", [
          _vm._v("\n        " + _vm._s(_vm.$t("layout_login.cashNow_help"))),
          _c("br"),
          _vm._v(
            "\n        " +
              _vm._s(_vm.$t("layout_login.invoicing_financial_platform"))
          ),
          _c("br"),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "content-bottom" }),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-main" }, [
      _c("a", { attrs: { href: "/admin" } }, [
        _c("img", {
          attrs: {
            src: "/assets/img/cash_logo_vertical.png",
            alt: "Cash Now Logo",
          },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }